export default {"src":"/_next/static/media/arrow-right-normal.1b88914e.svg","height":32,"width":34,"blurWidth":0,"blurHeight":0};